import styled from 'styled-components';

import { Text } from '@components';

const TextWrapper = styled(Text)`
  text-align: center;
`;

export default TextWrapper;
